export default "__VITE_ASSET__DqMPn54P__"